import pkg from '@siloreal:root:package' with { type: 'json' };

export const version = pkg.version;
